exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".auto-carousel{contain:content;width:100%}.auto-carousel .carousel .carousel-indicators{margin-top:auto}.auto-carousel .carousel .carousel-control-prev,.auto-carousel .carousel .carousel-control-next{display:none}.auto-carousel .buttonToggle{position:relative;float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Helpers/Widgets/AutoCarousel/AutoCarousel.scss
// module id = 7471
// module chunks = 13